"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegGa = void 0;
const base_1 = require("./base");
const ga_1 = require("../services/ga");
/**
 * Google Analytics
 */
class AnIntegGa extends base_1.AnIntegBase {
    static isLoaded() {
        return ga_1.AnServGa.isLoaded();
    }
    static sendPage(siteCategory, userId, email) {
        if (userId !== null && email !== null) {
            ga_1.AnServGa.sendIdentify(this.getPixelId(siteCategory), userId, email);
        }
        ga_1.AnServGa.sendPage(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackClubCheckoutStart(siteCategory) {
        ga_1.AnServGa.sendStdEventBeginCheckout("menlo", "New Flow: Subscription", "subscription");
        return true;
    }
    static sendTrackArriveSignupLoginLegacy(siteCategory) {
        ga_1.AnServGa.sendCustEventBeginSignup("menlo", "Legacy: Subscription");
        return true;
    }
    static sendTrackClubAccountCreate(siteCategory, userId, email) {
        ga_1.AnServGa.sendStdEventSignUp("menlo", "New Flow: Subscription");
        return true;
    }
    static sendTrackClubAccountCreateLegacy(siteCategory, userId, email) {
        ga_1.AnServGa.sendStdEventSignUp("menlo", "Legacy: Menlo Subscription");
        return true;
    }
    static sendTrackClubAddPaymentInfo(siteCategory) {
        ga_1.AnServGa.sendCustEventAddPaymentInfo("menlo", "New Flow: Subscription");
        return true;
    }
    static sendTrackClubAddPaymentInfoLegacy(siteCategory) {
        ga_1.AnServGa.sendCustEventAddPaymentInfo("menlo", "Legacy: Subscription");
        return true;
    }
    static sendTrackSubmittedPaymentReviewLegacy(siteCategory) {
        ga_1.AnServGa.sendCustEventReviewPaymentInfo("menlo", "Legacy: Subscription");
        return true;
    }
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        ga_1.AnServGa.sendStdEventSubscriptionPurchase("menlo", "New Flow: Subscription", userId, price, "subscription", coupon);
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        ga_1.AnServGa.sendStdEventSubscriptionPurchase("menlo", "Legacy: Subscription", userId, price, "subscription", coupon);
        return true;
    }
    static sendTrackEcommProductAddToCart(siteCategory, productId) {
        ga_1.AnServGa.sendStdEventEcommAddToCart(productId);
        return true;
    }
    static sendTrackEcommThankyou(siteCategory, userId, orderId, price, coupon) {
        ga_1.AnServGa.sendStdEventEcommPurchase("menlo", "Ecomm", orderId, price, coupon);
        return true;
    }
}
exports.AnIntegGa = AnIntegGa;
AnIntegGa.shouldSendEveryPage = true;
AnIntegGa.shouldSendTrackClubCheckoutStart = true;
AnIntegGa.shouldSendTrackArriveSignupLoginLegacy = true;
AnIntegGa.shouldSendTrackClubAccountCreate = true;
AnIntegGa.shouldSendTrackClubAccountCreateLegacy = true;
AnIntegGa.shouldSendTrackClubAddPaymentInfo = true;
AnIntegGa.shouldSendTrackClubAddPaymentInfoLegacy = true;
AnIntegGa.shouldSendTrackSubmittedPaymentReviewLegacy = true;
AnIntegGa.shouldSendTrackClubThankyou = true;
AnIntegGa.shouldSendTrackClubThankyouLegacy = true;
AnIntegGa.shouldSendTrackEcommThankyou = true;
AnIntegGa.shouldSendTrackEcommProductAddToCart = true;
AnIntegGa.pixelId = {
    prod: {
        defaultId: "UA-31499538-1",
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: "UA-31499538-1",
        ecomm: null,
        club: null,
    },
};
